export var ctaComponentAlignment = {
    left: "left",
    center: "center",
};
